import React from "react";
import { Link } from "react-router-dom";
import LanguageToggle from "@/components/LanguageToggle";
import { usePageMeta } from "@/hooks/usePageMeta";
import { applyTheme } from "@/themes/contract";
import { getTheme, themeList } from "@/themes/registry";
import {
    GALLERY_DESCRIPTION,
    GALLERY_TITLE,
    PALETTE_KEYS,
    SAMPLE_MARK,
    themeLabel,
} from "@/themes/sampleGallery";

export default function ThemeGalleryPage() {
    const pageTheme = getTheme("blossom-gold");
    usePageMeta(GALLERY_TITLE, GALLERY_DESCRIPTION);

    return (
        <div
            className="wd-theme wd-paper-texture min-h-[100dvh]"
            style={applyTheme(pageTheme)}
            data-ornament={pageTheme.ornament}
            data-testid="theme-gallery"
        >
            <div className="mx-auto max-w-6xl px-4 py-8 md:px-8 md:py-12">
                <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0 max-w-2xl flex-1">
                        <p className="text-sm font-medium text-[var(--wd-accent)]" data-testid="sample-mark">
                            {SAMPLE_MARK}
                        </p>
                        <h1 className="wd-heading mt-3 text-4xl text-[var(--wd-primary)] md:text-5xl">
                            سمات الدعوات
                        </h1>
                        <p className="wd-heading mt-1 text-2xl text-[var(--wd-accent)]" lang="en">
                            Wedding themes
                        </p>
                        <p className="mt-4 text-sm leading-relaxed text-[var(--wd-text-muted)]">
                            يوسف و ليلى · قاعة الياسمين · القاهرة
                            <span className="mx-2" aria-hidden="true">/</span>
                            <span lang="en">Youssef & Layla · Jasmine Hall · Cairo</span>
                        </p>
                    </div>
                    <LanguageToggle className="shrink-0 !bg-[var(--wd-bg)] !text-[var(--wd-text)] hover:!bg-[var(--wd-bg-alt)]" />
                </div>

                <ul className="mt-10 grid list-none grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {themeList.map((theme) => {
                        const label = themeLabel(theme);
                        return (
                            <li key={theme.id}>
                                <Link
                                    to={`/themes/${theme.id}`}
                                    data-testid={`theme-card-${theme.id}`}
                                    data-ornament={theme.ornament}
                                    className="wd-theme wd-paper-texture block h-full border border-[var(--wd-border)] p-5 shadow-sm transition hover:-translate-y-0.5"
                                    style={{
                                        ...applyTheme(theme),
                                        borderRadius: "var(--wd-radius)",
                                    }}
                                >
                                    <h2 className="wd-heading text-2xl text-[var(--wd-primary)]" data-testid="theme-name">
                                        {theme.name}
                                    </h2>
                                    <p className="mt-2 text-sm text-[var(--wd-text)]" lang="ar" data-testid="theme-label-ar">
                                        {label.ar}
                                    </p>
                                    <p className="text-sm text-[var(--wd-text-muted)]" lang="en" data-testid="theme-label-en">
                                        {label.en}
                                    </p>
                                    <div
                                        className="mt-4 flex gap-2"
                                        data-testid={`theme-palette-${theme.id}`}
                                        aria-hidden="true"
                                    >
                                        {PALETTE_KEYS.map((key) => (
                                            <span
                                                key={key}
                                                className="h-6 w-6 rounded-full border border-[var(--wd-border)]"
                                                style={{ background: theme.colors[key] }}
                                                title={`${key} ${theme.colors[key]}`}
                                            />
                                        ))}
                                    </div>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
